const _excluded = ["children", "className", "shadow", "radius"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from 'react';
import classNames from 'clsx';
import Box from "../Box";
import absurd from "../lib/absurd";
const getRadiusClass = radius => {
  switch (radius) {
    case 'none':
      return null;
    case 'all':
      return 'Card--radius--all';
    case 'circle':
      return 'Card--radius--circle';
    case 'bottom':
      return 'Card--radius--bottom';
    case 'bottomLeft':
      return 'Card--radius--bottomLeft';
    case 'bottomRight':
      return 'Card--radius--bottomRight';
    case 'left':
      return 'Card--radius--left';
    case 'right':
      return 'Card--radius--right';
    case 'top':
      return 'Card--radius--top';
    case 'topLeft':
      return 'Card--radius--topLeft';
    case 'topRight':
      return 'Card--radius--topRight';
    default:
      return absurd(radius);
  }
};
const getShadowClass = shadow => {
  switch (shadow) {
    case 'none':
      return null;
    case 'keyline':
      return 'Card--shadow--keyline';
    case 'small':
      return 'Card--shadow--small';
    case 'medium':
      return 'Card--shadow--medium';
    case 'large':
      return 'Card--shadow--large';
    case 'extra-large':
      return 'Card--shadow--extraLarge';
    default:
      return absurd(shadow);
  }
};
class Card extends React.Component {
  render() {
    const _this$props = this.props,
      {
        children,
        className,
        shadow,
        radius
      } = _this$props,
      remaining = _objectWithoutProperties(_this$props, _excluded);
    const radiusClass = getRadiusClass(radius);
    const shadowClass = getShadowClass(shadow);
    const classes = classNames('Card-root', radiusClass, shadowClass, className);
    return /*#__PURE__*/React.createElement(Box, _extends({}, remaining, {
      className: classes,
      background: "white"
    }), children);
  }
}
Card.defaultProps = {
  radius: 'all',
  shadow: 'medium'
};
export default Card;